import type { HttpError } from '@refinedev/core'
import axios from 'axios'

import { config } from '@/config'

import { getApiErrorMessage } from './error-message'

const axiosInstance = axios.create({
	withCredentials: true, // Include cookies with requests
})

export const IGNORE_TIMEOUT_HEADERS = { 'Ignore-Timeout': 'true' } as const

axiosInstance.defaults.baseURL = config.fridge.apiUrl

const urlParams = new URLSearchParams(window.location.search)
const impersonateParam = urlParams.get('impersonate')
if (impersonateParam) {
  axiosInstance.defaults.headers.common['X-IMPERSONATE'] = impersonateParam
}

axiosInstance.interceptors.response.use(
	(response) => {
		const data = response.data
		if (
			response.status === 202 &&
			typeof data === 'object' &&
			data !== null &&
			typeof data.status === 'number' &&
			data.status >= 400
		) {
			const customError: HttpError = {
				...data,
				message: [data.data, data.error, data.message].find((value): value is string => typeof value === 'string') ?? 'Request failed',
				statusCode: data.status,
			}

			return Promise.reject(customError)
		}

		return response
	},
	(error) => {
		const customError: HttpError = {
			...error,
			message: getApiErrorMessage(error.response?.data, error.message),
			statusCode: error.response?.status,
		}

		return Promise.reject(customError)
	}
)

export { axiosInstance }
